import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import {RightArrow} from './icons'
import Link from '../utils/link'

const FeaturedProjects = ({ projects }) => {

  const props = {
    onMouseEnter: () => window?._handleMouseEnter('View'),
    onMouseLeave: () => window?._handleMouseLeave(),
    className: 'featured-projects__item',
  }

  return (
    <section className='featured-projects'>
      <div className='featured-projects__inner'>
        { projects?.length &&
          <div className='featured-projects__items'>
            { projects?.map((el, i) => {
              let image = el.acf?.thumbnail?.landscapeImage?.localFile
              if ((i + 1) % 2 === 0) image = el.acf?.thumbnail?.portraitImage?.localFile
              return (
                <Link key={i} to={el.uri} className='featured-projects__item' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease' {...props}>
                  { el.acf.thumbnail?.video &&
                    <div className={`featured-projects__video-thumb featured-projects__video-thumb--${el.acf.thumbnail.videoSize}`}>
                      <video src={el.acf.thumbnail.video} autoPlay muted loop playsInline />
                    </div>
                  }
                  { !el.acf.thumbnail.video && image?.extension !== 'gif' && <GatsbyImage image={getImage(image)} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                  { !el.acf.thumbnail.video && image?.extension === 'gif' && <img className='gif' src={image.publicURL} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                  <div className='featured-projects__cap'>
                    { el.title && <h4>{parse(el.title)}</h4> }
                    { el.acf?.subtitle && <p>{parse(el.acf.subtitle)}</p> }
                  </div>
                </Link>
              )
            })}
          </div>
        }
        <div className='featured-projects__all'>
          <Link to='/projects/'>
            <span>View all Projects</span>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default FeaturedProjects
